import React from 'react';
import Spline from '@splinetool/react-spline';
import { ArrowRight, Shield } from 'lucide-react';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-left">
          <div className="hero-badge">
            <Shield className="hero-badge-icon" />
            <span>Cybersecurity Wizardry</span>
          </div>

          <h1 className="hero-title">
            Next Level
            <span className="hero-title-accent"> CyberSecurity Solutions</span>
          </h1>

          <p className="hero-description">
            Expert cybersecurity consulting services including vulnerability management,
            risk assessment, penetration testing, and compliance audits. Protect your
            organization with proven security strategies.
          </p>

          <div className="hero-buttons">
            <button
              onClick={scrollToContact}
              className="btn-primary"
            >
              Get Security Assessment
              <ArrowRight size={20} />
            </button>

            <button
              onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
              className="btn-secondary"
            >
              View Services
            </button>
          </div>

          <div className="hero-stats">
            <div className="hero-stat">
              <span className="hero-stat-number">500+</span>
              <span className="hero-stat-label">Organizations Secured</span>
            </div>
            <div className="hero-stat">
              <span className="hero-stat-number">99.9%</span>
              <span className="hero-stat-label">Threat Detection Rate</span>
            </div>
            <div className="hero-stat">
              <span className="hero-stat-number">24/7</span>
              <span className="hero-stat-label">Security Monitoring</span>
            </div>
          </div>
        </div>

        <div className="hero-right">
          <div className="spline-container">
            <Spline
              scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;